export const json = {
  locale: 'ko_kr',
  recipe: "레시피",
  machine: "기계",
  task: {
    state: {
      unset: "설정되지 않음",
      todo: "할 일",
      in_progress: "진행 중",
      to_test: "테스트 필요",
      wont_fix: "수정 안 함",
      done: "완료",
      paused: "일시 중지",
    },
    priority: {
      unset: "우선순위 없음",
      low: "낮음",
      normal: "보통",
      high: "높음",
      max: "긴급",
    },
    table: {
      header: {
        title: "작업",
        state: "상태",
        priority: "우선순위",
        labels: "라벨",
      },
      placeholder: {
        filter: {
          priority: "이메일 필터링...",
        },
      },
      "no-results": "결과 없음",
    },
    add: {
      title: "새 작업 추가",
      name: "작업 이름",
      name_placeholder: "작업 이름 입력",
      priority: "우선순위",
      title_translations: "제목 번역",
      description_translations: "설명 번역",
      icon_url: "아이콘 URL (선택사항)",
      icon_url_placeholder: "아이콘 URL 입력",
      labels: "라벨",
      assigned_to: "담당자",
      assigned_to_placeholder: "관리자 선택",
      submit: "작업 생성",
      cancel: "취소",
      edit_translations: "번역 편집",
      save_translations: "번역 저장",
      required_field: "이 필드는 필수입니다",
      en_us_required: "영어(US) 번역이 필요합니다",
      success: "작업이 성공적으로 생성되었습니다!",
      error: "작업 생성 중 오류가 발생했습니다. 다시 시도해 주세요.",
    },
  },
  table: {
    select: {
      of: "중",
      rows: "행이 선택되었습니다.",
    },
  },
  cookies: {
    link: '쿠키 정책',
    title: "쿠키 동의",
    description:
      "이 웹사이트는 적절한 기능을 보장하고 경험을 향상시키기 위해 쿠키를 사용합니다. 어떤 쿠키를 사용할 수 있는지 선택해 주세요.",
    policy_link: "쿠키 정책에서 자세히 알아보기",
    accept_all: "모두 수락",
    accept_selected: "선택 항목 수락",
    accept_essential: "필수만",
    manage: "환경설정 관리",
    save: "환경설정 저장",
    back: "뒤로",
    categories: {
      essential: {
        title: "필수 쿠키",
        description: "이 쿠키는 웹사이트 기능에 필요하며 비활성화할 수 없습니다.",
      },
      functional: {
        title: "기능 쿠키",
        description: "이 쿠키는 개인화된 기능과 특징을 가능하게 합니다.",
      },
      analytics: {
        title: "분석 쿠키",
        description: "이 쿠키는 방문자가 웹사이트와 어떻게 상호작용하는지 이해하는 데 도움이 됩니다.",
      },
      marketing: {
        title: "마케팅 쿠키",
        description: "이 쿠키는 광고 목적으로 웹사이트 간에 방문자를 추적하는 데 사용됩니다.",
      },
    },
    expiration: {
      title: "쿠키 만료",
      description: "쿠키 환경설정이 기억될 기간을 선택하세요:",
      thirty_days: "30일",
      ninety_days: "90일",
      six_months: "6개월",
      one_year: "1년",
    },
    policy: {
      title: "쿠키 정책",
      introduction:
        "이 쿠키 정책은 웹사이트를 방문할 때 귀하를 인식하기 위해 쿠키 및 유사한 기술을 어떻게 사용하는지 설명합니다. 이러한 기술이 무엇인지, 왜 사용하는지, 그리고 이러한 기술의 사용을 제어할 수 있는 귀하의 권리에 대해 설명합니다.",
      what_are_cookies: "쿠키란 무엇인가요?",
      what_are_cookies_text:
        "쿠키는 웹사이트를 방문할 때 컴퓨터나 모바일 장치에 배치되는 작은 데이터 파일입니다. 쿠키는 웹사이트 소유자가 웹사이트를 작동시키거나 더 효율적으로 작동시키기 위해, 그리고 보고 정보를 제공하기 위해 널리 사용됩니다.",
      how_we_use: "쿠키 사용 방법",
      how_we_use_text:
        "우리는 여러 가지 이유로 쿠키를 사용합니다. 일부 쿠키는 웹사이트가 작동하기 위해 기술적인 이유로 필요하며, 이를 '필수' 또는 '필요' 쿠키라고 합니다. 다른 쿠키는 웹사이트에서의 경험을 향상시키기 위해 사용자의 관심사를 추적하고 타겟팅할 수 있게 해줍니다. 제3자는 광고, 분석 및 기타 목적을 위해 웹사이트를 통해 쿠키를 제공합니다.",
      types: "사용하는 쿠키 유형",
      managing: "쿠키 관리",
      managing_text:
        "웹 브라우저 컨트롤을 설정하거나 수정하여 쿠키를 수락하거나 거부할 수 있습니다. 쿠키를 거부하기로 선택한 경우에도 웹사이트를 계속 사용할 수 있지만, 웹사이트의 일부 기능과 영역에 대한 접근이 제한될 수 있습니다. 웹 브라우저 컨트롤을 통해 쿠키를 거부하는 방법은 브라우저마다 다르므로, 자세한 정보는 브라우저의 도움말 메뉴를 참조하세요.",
      third_party: "제3자 쿠키",
      third_party_text:
        "자체 쿠키 외에도, 웹사이트 사용 통계를 보고하거나, 웹사이트에 광고를 게재하는 등의 목적으로 다양한 제3자 쿠키를 사용할 수 있습니다.",
      updates: "이 쿠키 정책 업데이트",
      updates_text:
        "우리는 사용하는 쿠키의 변경 사항이나 기타 운영, 법적 또는 규제 이유를 반영하기 위해 이 쿠키 정책을 수시로 업데이트할 수 있습니다. 따라서 쿠키 및 관련 기술 사용에 대한 최신 정보를 얻기 위해 이 쿠키 정책을 정기적으로 다시 방문하세요.",
      purpose: "목적",
      essential_purpose:
        "웹사이트의 적절한 기능에 필요합니다. 이 쿠키는 페이지 탐색 및 웹사이트의 보안 영역 접근과 같은 기본 기능을 가능하게 합니다.",
      functional_purpose:
        "웹사이트가 사용자 이름, 언어 또는 지역과 같은 선택 사항을 기억하고 향상된 개인화된 기능을 제공할 수 있게 합니다.",
      analytics_purpose:
        "방문자가 웹사이트와 어떻게 상호작용하는지 이해하는 데 도움이 되며, 익명으로 정보를 수집하고 보고합니다.",
      marketing_purpose:
        "웹사이트 간에 방문자를 추적하는 데 사용됩니다. 개별 사용자에게 관련성 있고 매력적인 광고를 표시하는 것이 목적입니다.",
      always_active: "항상 활성화",
      active: "활성화",
      inactive: "비활성화",
      back_to_site: "사이트로 돌아가기",
    },
  },
  sidebar: {
    platform: "플랫폼",
    dashboard: "대시보드",
    tasks: {
      title: "작업",
      add: "작업 추가"
    },
    analytics: "분석",
    users: "사용자",
    settings: "설정",
    admin_panel: {
      title: "관리자 패널",
      mods: {
        title: "관리자",
        add: "관리자 추가"
      },
      labels: {
        title: "라벨",
        add: "라벨 추가"
      },
      pending: "승인 대기 중"
    },
    documentation: {
      title: "문서",
      create: "문서 생성"
    },
    search: "문서 검색..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "개요",
          userInfo: "사용자 정보",
          userId: "사용자 ID",
          role: "역할",
          memberSince: "가입일"
        },
        tasks: {
          title: "작업",
          assigned: "할당된 작업",
          noTasks: "아직 할당된 작업이 없습니다."
        },
        activity: {
          title: "활동",
          recent: "최근 활동",
          noActivity: "최근 활동이 없습니다."
        },
        settings: {
          title: "설정",
          user: "사용자 설정",
          admin: "이 사용자에 대한 관리자 설정."
        }
      }
    },
    mods: {
      error: {
        unknownError: "알 수 없는 오류"
      },
      access: {
        title: "접근 거부",
        description: "이 페이지에 접근할 권한이 없습니다."
      },
      add: {
        link: "새 모드 추가",
        title: "새 모드 추가",
        addDesc: "새 모드 항목 생성",
        name: {
          title: "이름",
          placeholder: "모드 이름 입력"
        },
        description: {
          title: "설명",
          placholder: "설명 입력 "
        },
        optional: "선택사항",
        versions: {
          title: "버전",
          add: "버전 추가"
        },
        icon: "아이콘 URL",
        launchers: "런처",
        form: {
          errors: {
            alert: {
              title: "오류",
              description: "제출하기 전에 위의 오류를 수정해 주세요."
            },
            name: "이름은 필수입니다",
            description: "영어(US) 설명은 필수입니다",
            curseforge: "CurseForge 링크는 필수입니다",
            invalidURL: "잘못된 URL 형식",
            versions: "최소 하나의 버전이 필요합니다",
            launchers: "최소 하나의 런처가 필요합니다"
          }
        },
        cancel: "취소",
        create: {
          loading: "생성 중...",
          default: "모드 생성"
        },
        langDataError: "언어 데이터 로드 중 오류:",
      },
      noMods: "모드를 찾을 수 없음",
      getStarted: "새 모드를 생성하여 시작하세요.",
      fetch: {
        error: '문서 가져오기 오류:'
      },
      "delete": {
        link: "삭제",
        confirm: "이 모드를 삭제하시겠습니까?"
      },
      toast: {
        delete: {
          success: {
            title: "모드 삭제됨",
            description: "모드가 성공적으로 삭제되었습니다."
          },
          error: {
            console: "모드 삭제 중 오류:",
            fallback: "모드 삭제 실패",
            title: "오류",
            description: "모드 삭제 중 오류가 발생했습니다."
          }
        },
        edit: {
          success: {
            title: "성공",
            description: "모드가 성공적으로 업데이트되었습니다"
          }
        },
        add: {
          fallback: "모드 생성 실패",
          success: {
            title: "성공",
            description: "모드가 성공적으로 생성되었습니다"
          },
          console: "모드 생성 중 오류:",
          error: {
            title: "오류",
            description: "모드 생성 실패"
          }
        }
      },
      noDesc: "사용 가능한 설명 없음",
      docs: {
        link: "문서"
      },
      edit: {
        link: "편집",
        title: "모드 편집",
        langDataError: "언어 데이터 로드 중 오류:",
        notFound: "모드를 찾을 수 없음",
        failFetch: "모드 가져오기 실패",
        unknownError: "알 수 없는 오류가 발생했습니다",
        form: {
          errors: {
            name: "이름은 필수입니다",
            description: "영어(US) 설명은 필수입니다",
            curseforge: "CurseForge 링크는 필수입니다",
            versions: "모든 버전 필드를 작성해야 합니다",
            launchers: "최소 하나의 런처를 선택해야 합니다"
          }
        },
        modInfo: "모드 정보",
        editModInfo: "모드 정보 편집.",
        name: "이름",
        description: {
          title: "설명",
          required: "영어(US) 설명은 필수입니다."
        },
        optional: "선택사항",
        versions: {
          title: "버전",
          add: "버전 추가",
          remove: "제거"
        },
        icon: "아이콘 URL",
        launchers: "런처",
        cancel: "취소",
        update: "모드 업데이트"
      }
    },
    docs: {
      access: {
        title: "접근 거부",
        description: "이 페이지에 접근할 권한이 없습니다."
      },
      title: "문서",
      description: "마인크래프트 모드에 대한 문서 탐색 및 읽기",
      create: {
        link: "문서 생성",
        tab: "새로 생성",
        content: {
          title: "사용 가능한 모드 없음",
          description: "모든 모드에 이미 문서가 있거나 모드에 대한 문서를 생성할 권한이 없습니다."
        },
        title: "문서 생성"
      },
      published: "게시됨",
      pending: "대기 중",
      noDocs: {
        title: "사용 가능한 문서 없음",
        description: "아직 게시된 문서 페이지가 없습니다."
      },
      noPending: {
        title: "대기 중인 문서 없음",
        superAdmin: "승인 대기 중인 문서 페이지가 없습니다",
        rest: "대기 중인 문서 페이지가 없습니다."
      },
      user: {
        noDocs: {
          title: "사용 가능한 문서 없음",
          description: "아직 게시된 문서 페이지가 없습니다."
        }
      },
      card: {
        pending: "승인 대기 중",
        view: "보기",
        edit: "편집"
      },
      add: {
        title: "새 문서 생성",
        description: "마인크래프트 모드에 대한 포괄적인 문서 생성",
        noMods: {
          title: "사용 가능한 모드 없음",
          description: "문서 생성에 사용 가능한 모드가 없습니다. 모든 모드에 이미 문서가 있거나 모드에 대한 문서를 생성할 권한이 없습니다."
        },
        card: {
          title: "기본 정보",
          description: "문서에 대한 기본 정보를 제공하세요.",
          descriptionLink: "문서 가이드 보기",
          content: {
            modSelect: "모드 선택",
            modSelectDesc: "문서를 생성하려는 모드를 선택하세요",
            noDesc: "사용 가능한 설명 없음",
            form: {
              title: {
                title: "제목",
                placeholder: "문서 제목 입력",
                description: "문서의 제목 (영어 US 필수)"
              },
              description: {
                title: "설명",
                placeholder: "문서 설명 입력",
                description: "문서에 대한 간략한 설명 (영어 US 필수)"
              },
              coverImage: {
                title: "커버 이미지 URL (선택사항)",
                description: "문서의 커버 이미지에 대한 URL 제공"
              },
              tabs: {
                preview: {
                  title: "미리보기",
                  content: {
                    title: "미리보기",
                    description: "문서가 어떻게 보일지 미리보기",
                    form: {
                      title: "문서 제목",
                      description: "문서 설명이 여기에 표시됩니다."
                    },
                    section: "섹션",
                    article: "아티클",
                    modSelect: {
                      title: "모드 선택",
                      description: "문서를 미리보기할 모드 선택"
                    }
                  }
                },
                information: {
                  title: "정보",
                  content: {
                    title: "정보",
                    description: "문서 생성에 관한 중요 정보",
                    approval: {
                      title: "승인 필요",
                      description: "편집자 및 관리자가 생성한 문서는 공개되기 전에 슈퍼 관리자의 승인이 필요합니다. 이를 요청하려면 티켓을 열어주세요."
                    },
                    after: {
                      title: "생성 후:",
                      list: {
                        one: "문서 편집기로 리디렉션됩니다",
                        two: "기본 섹션과 아티클이 자동으로 생성됩니다",
                        three: "필요에 따라 추가 섹션과 아티클을 추가할 수 있습니다",
                        four: "이미지를 업로드하고 사용자 정의 구성 요소를 추가할 수 있습니다",
                        five: "승인을 위해 제출하기 전에 문서를 미리볼 수 있습니다. (미리보기 전에 저장해야 합니다)"
                      }
                    },
                    create: {
                      loading: "생성 중...",
                      default: "문서 생성"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "모드 가져오기 실패",
          documentation: "문서 가져오기 실패"
        },
        success: {
          title: "문서 생성됨",
          description: "문서가 성공적으로 생성되었습니다."
        },
        error: {
          fetching: {
            mods: {
              console: "모드 가져오기 오류:",
              toast: {
                title: "오류",
                description: "모드 로드 실패. 다시 시도해 주세요."
              }
            }
          },
          creating: {
            failed: "문서 생성 실패",
            error: {
              console: "문서 생성 중 오류:",
              toast: {
                title: "오류",
                description: "문서 생성 실패. 다시 시도해 주세요."
              }
            }
          }
        }
      }
    }
  }
}